import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BenefitItem } from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  background:
    'radial-gradient(256.02% 160.24% at 91.43% -54.79%, #5D5D5D 0%, #3A3A3A 48.91%, #303030 79.53%)',
  padding: theme.spacing(6, 0, 0, 0),
  overflowX: 'hidden',
  [theme.breakpoints.down('xxl')]: {
    padding: theme.spacing(6, 0, 3, 0),
  },
  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(6, 0, 3, 0),
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(3, 0, 3, 0),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 0, 3, 0),
  },
  '& .HISWrapper': {
    position: 'relative',
    minHeight: theme.typography.pxToRem(540),
    [theme.breakpoints.down('lg')]: {
      minHeight: 'unset',
    },
  },
  '& .HISBG': {
    width: theme.typography.pxToRem(951),
    height: theme.typography.pxToRem(540),
    position: 'absolute',
    left: '58%',
    top: theme.spacing(0),
    [theme.breakpoints.down('xxl')]: {
      width: theme.typography.pxToRem(951),
      left: '50%',
    },
    [theme.breakpoints.down('xl')]: {
      width: theme.typography.pxToRem(951),
      left: '59%',
    },
    [theme.breakpoints.down('lg')]: {
      left: '4%',
      position: 'relative',
      width: theme.typography.pxToRem(786),
      height: theme.typography.pxToRem(446),
      marginLeft: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(653),
      height: theme.typography.pxToRem(371),
    },
  },
  '& .HISDetails': {
    width: theme.typography.pxToRem(800),
    [theme.breakpoints.down('xxl')]: {
      width: theme.typography.pxToRem(600),
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginTop: theme.spacing(1.5),
    },
  },
  '& .HISTitle': {
    lineHeight: theme.typography.pxToRem(58),
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('xxl')]: {
      fontSize: theme.typography.pxToRem(38),
      lineHeight: theme.typography.pxToRem(48),
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(32),
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(32),
    },
  },
  '& .HISSubTitle': {
    color: theme.palette.grey[100],
    marginBottom: theme.typography.pxToRem(48),
  },
  '& .HISPriceBox': {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.secondary.dark,
  },

  '& .HISNote': {
    margin: theme.spacing(1, 0.5, 0.5, 0.5),
    color: theme.palette.grey[200],
  },
  '& .HISBenfitItem': {
    marginBottom: theme.spacing(0.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  '& .HISPricAndSub': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  },
  '& .HISPricePerMonth': {
    fontSize: theme.typography.pxToRem(21),
    lineHeight: theme.typography.pxToRem(32),
    padding: theme.spacing(2, 0),
  },
  '& .HISPrice': {
    fontSize: theme.typography.pxToRem(60),
    lineHeight: theme.typography.pxToRem(48),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(40),
    },
  },
  '& .HISPriceStar': {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(18),
    verticalAlign: 'top',
  },
  '& .HISSubBtnContainer': {
    height: theme.spacing(10),
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      height: 'fit-content',
      marginTop: theme.spacing(1),
    },
  },
  '& .HISSubBtn': {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(26),
    fontWeight: 700,
    padding: theme.spacing(0),
    height: 'fit-content',
  },
  '& .HISCheckIcon': {
    color: theme.palette.grey[100],
  },
}));

export const StyledBenefitItem = styled(BenefitItem)(({ theme }) => ({
  '& .BenfitItem-benefitContainer': {
    color: theme.palette.grey[100],
    fontSize: `${theme.typography.pxToRem(16)} !important`,
    lineHeight: ` ${theme.typography.pxToRem(24)} !important`,
  },
}));

export default StyledBox;
